module.exports = __webpack_public_path__ + "img/coupon_2026.d00d5f11.png";